module.exports = __webpack_public_path__ + "img/icon-dangerous-goods-woodpacking-text.32011639.svg";